exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[data-v-5e3213c8] {\n  background-color:#0769ba;\n  color:white;\n  padding:10px;\n  border-radius:25px;\n}\n", ""]);

// exports
